<template>
  <b-modal
    id="customer-group"
    ref="customer-group"
    centered
    hide-footer
    size="sm"
    @hide="closeModal"
    no-close-on-backdrop
    no-close-on-esc
  >
    <template v-slot:modal-title>Assign customer group</template>
    <div
      class="d-block group-listing overflow-auto item-list"
      style="max-height: 40vh; max-width: 100%"
      v-if="group_list.length > 0"
    >
      <b-row class="py-2">
        <b-col md="12">
          <div
            class="custom-check hover-color mb-1"
            v-for="group in group_list"
            :key="group.id"
            @click="selectCheckBox(group)"
          >
            <div :id="'zwing-' + group.id" >
              <input
                class="pull-right"
                type="checkbox"
                :id="'input-' + group.id"
                :checked="group.selected"
              />
              <label
                :for="group.id"
                v-text="`     ${_.startCase(group.name)}`"
                class="ml-2"
                :id="group.name + '-' + group.id"
              ></label>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- add new group -->
      <!-- <b-input-group class="mb-3 mt-3 add-group-field">
        <template v-slot:append>
          <b-input-group-text>
            <img src="../assets/images/remove.svg" alt="Clear" style="cursor:pointer" />
          </b-input-group-text>
        </template>
        <b-form-input></b-form-input>
      </b-input-group>-->
      <!-- <p class="my-3">
        <b-link title="Add new group" class="add-new">
          <img src="../assets/images/add_green.svg" alt=" " class="mr-2" />
          Add new group
        </b-link>
      </p>-->
    </div>
    <div
      v-else
      class="d-flex justify-content-center align-items-center"
      style="min-height: 10vh"
    >
      <p>No groups found.</p>
    </div>
    <div class="text-right" v-if="group_list.length > 0">
      <b-button
        variant="primary"
        class="mt-3"
        :disabled="$loading"
        @click="updateCustomerGroup"
        id="save-customer-group"
      >
        <span v-if="$loading == false">Save</span>
        <b-spinner small v-if="$loading == true"></b-spinner>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";

export default {
  name: "customer-group",
  props: ["open", "c_id"],
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    _() {
      return _;
    },
  },
  data() {
    return {
      group_list: [],
    };
  },
  watch: {
    open() {
      if (this.open) this.fetchCustomerGroup();
      else this.$refs["customer-group"].hide();
    },
  },
  methods: {
    fetchCustomerGroup() {
      this.$loading = true;
      let postData = {
        user_id: this.c_id,
        url: "/customer/group-list",
      };
      let data = Object.assign(postData, this.essentialsData);
      axios
        .post(data.url, data)
        .then((res) => {
          this.group_list = res.data.customer_group_list;
          this.$refs["customer-group"].show();
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    updateCustomerGroup() {
      this.$loading = true;
      let postData = {
        customer_group_list: JSON.stringify(this.group_list),
        user_id: this.c_id,
        url: "/customer/update-group-list",
      };
      let data = Object.assign(postData, this.essentialsData);
      axios
        .post(data.url, data)
        .then((res) => {
          this.$refs["customer-group"].hide();
          let alertData = {
            message:
              res.data.status == "success"
                ? msg.CUSTOMER_GROUP_UPDATED
                : res.data.message,
            type: res.data.status == "success" ? "success" : "danger",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    selectCheckBox(group) {
      let findObj = _.findIndex(this.group_list, group);
      if (group.selected) this.group_list[findObj].selected = false;
      else this.group_list[findObj].selected = true;
    },
    closeModal() {
      this.$emit("close-group-modal", this.group_list);
    },
  },
};
</script>

<style scoped lang="scss">
.item-list {
  overflow-x: hidden !important;
  @include custom-scrollbar();
}
.hover-color {
  padding-top: 6px;
  padding-bottom: 2px;
  cursor: pointer;
  &:hover {
    background-color: #d0d0d0;
  }
}
</style>
